import React, { useState, useEffect } from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import AddIcon from '@material-ui/icons/Add'
import { withRouter } from 'react-router-dom'

import { Breadcrumbs } from 'Components/Breadcrumbs'
import { CardsList } from 'Components/CardsList'
import { ClientCard } from 'Components/Clients/ClientCard'
import { ClientsWrapper } from 'Components/Clients/ClientsWrapper'
import { PageTitle } from 'Components/PageTitle'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { STATUS_FILTER } from '../../Reducers/Clients/const'
import ClientsIcon from 'Assets/Images/icons/clients'
import { globalSort } from '../../shared/libraries/sort'
import { getClients as getClientsGraphQL } from '../../Module/graphQL/index'
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator'
import useGraphQLFetch from '../../Utils/Hooks/useGraphQLFetch'
import { normalizeGraphQLConnection } from '../../shared/graphql/utils'
import Pagination from '../../Components/FilterAndPaginationComponent/Pagination'
import { isDefined } from '../../shared/libraries/utils/object'
import StyledIconButton from '../../Components/Form/StyledIconButton'
import { FilterSelect } from 'Components/Filter/FilterSelect'

const resultsPerPage = 50

const Clients = props => {
  const { url } = props.match
  const [statusFilter, setStatusFilter] = useState(STATUS_FILTER.ACTIVE)
  const [offsetRecordsStart, setOffsetRecordsStart] = useState(0)

  const { data, isLoading, refetch } = useGraphQLFetch({
    fetchFn: args => {
      const statuses = []

      if ([STATUS_FILTER.ACTIVE, STATUS_FILTER.ALL].includes(statusFilter)) {
        statuses.push('ACTIVE')
      }
      if ([STATUS_FILTER.ARCHIVED, STATUS_FILTER.ALL].includes(statusFilter)) {
        statuses.push('DELETED')
      }

      return getClientsGraphQL({
        statuses,
        first: resultsPerPage,
        ...args,
      })
    },
    mapResponse: ({ clients }) => ({
      clients: clients,
      pageInfo: clients.pageInfo,
      totalCount: clients.totalCount,
    }),
    defaultData: { clients: { edges: [] } },
  })

  useEffect(() => {
    refetch({
      skip: offsetRecordsStart,
      first: resultsPerPage,
    })
  }, [statusFilter, offsetRecordsStart])

  const statusFilterOptions = [
    { value: STATUS_FILTER.ACTIVE, label: 'Active' },
    { value: STATUS_FILTER.ARCHIVED, label: 'Archived' },
    { value: STATUS_FILTER.ALL, label: 'All' },
  ]

  const sortedClients = globalSort({
    data: normalizeGraphQLConnection(data.clients),
    sortingKey: 'name',
  })

  const onOffsetChange = offset => {
    if (offset < 0) offset = 0
    if (offset > data.totalCount) return

    setOffsetRecordsStart(offset)
  }
  const onChangeFilterStatus = (e, index, value) => {
    setStatusFilter(value)
  }
  return (
    <LayoutDashboard>
      <HideWhenBlocked>
        <ClientsWrapper>
          <Breadcrumbs icon={<ClientsIcon style={{ width: 24 }} />} />
          <Breadcrumb data={{ title: 'Clients', pathname: props.match.url }} />
          <PageTitle>Clients</PageTitle>

          <Link id="add-client-button" to={`${url}/add`}>
            <StyledIconButton>
              <AddIcon />
            </StyledIconButton>
          </Link>

          <FilterSelect
            className="country-selector"
            label="Status"
            options={statusFilterOptions}
            value={statusFilter}
            onChange={onChangeFilterStatus}
            sorted={true}
          />
          {isLoading && <LoadingIndicator />}
          <CardsList>
            {sortedClients.map((client, index) => {
              return (
                <Col xs={3} key={index}>
                  <ClientCard
                    client={client}
                    editPath={`${props.match.url}/${client.id}/edit`}
                    onClickHandler={props.history.push}
                    viewPath={`${props.match.url}/${client.id}`}
                  />
                </Col>
              )
            })}
          </CardsList>
          <Pagination
            total={
              isDefined(data.totalCount)
                ? data.totalCount
                : sortedClients.length
            }
            offset={isDefined(offsetRecordsStart) ? offsetRecordsStart : 0}
            resultsPerPage={
              isDefined(resultsPerPage) ? resultsPerPage : sortedClients.length
            }
            onOffsetChange={onOffsetChange}
            // className={classes.pagination}
          />
        </ClientsWrapper>
      </HideWhenBlocked>
    </LayoutDashboard>
  )
}

export default withRouter(Clients)



// WEBPACK FOOTER //
// ./src/Containers/Clients/index.js